import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import { ErrorBoundary } from "./components/shared/ErrorBoundary";
import { PaymentsPage } from "./components/PaymentsPage";
import { CallbackPage } from "./components/PaymentCallbackPage";
import ForgotPasswordFlow from './components/ForgotPasswordFlow';
import { LandingPage } from './components/LandingPage';
// import { SplashScreen } from '@capacitor/splash-screen';

// Lazy load main App component for code splitting
const App = lazy(() => import("./App"));

const LoadingFallback = () => (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
            <p className="text-gray-600 dark:text-gray-400">در حال بارگذاری...</p>
        </div>
    </div>
);

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
);
root.render(
    <React.StrictMode>
        <ErrorBoundary>
            <BrowserRouter
                future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
            >
                <Suspense fallback={<LoadingFallback />}>
                    <Routes>
                        <Route path="/" element={<App />} />
                        <Route path="/chat/:chatId" element={<App />} />
                        <Route path="/login" element={<App />} />
                        <Route path="/profile" element={<App />} />
                        <Route path="/subscriptions" element={<App />} />
                        <Route path="/models" element={<App />} />
                        <Route path="/connectors" element={<App />} />
                        {/*<Route path="/subscriptions123" element={<SubscriptionsPage/>}/>*/}
                        <Route path="/payment" element={<PaymentsPage />} />
                        <Route path="/payments/callback" element={<CallbackPage />} />
                        <Route path="/reset-password" element={<ForgotPasswordFlow />} />
                        <Route path="/landing" element={<LandingPage />} />
                        <Route path="/about" element={<App />} />
                        <Route path="/terms" element={<App />} />
                        <Route path="/contact" element={<App />} />
                    </Routes>
                </Suspense>
            </BrowserRouter>
        </ErrorBoundary>
    </React.StrictMode>,
);

// SplashScreen.hide({ fadeOutDuration: 600 }).catch(() => { });
